<template>
  <div>
    <b-modal
      :id="modalId || 'bv-notifications-confirmation'"
      ref="notificationsConfirmationModal"
      scrollable
      centered
      cancel-disabled
      ok-disabled
      no-stacking
      hide-header
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      size="lg"
    >
      <div class="padding">
        <VHeader :modal-button="true" @close-modal="closeModal">
          <template #modal-title>{{ title }}</template>
        </VHeader>
        <p>
          When your job is complete, you'll see a notification appear in the
          tray.
        </p>
        <img
          :src="gifSrc"
          alt="A numbered badge appears on the notification tray button in the page header. Interacting with that button reveals the notification tray. Toasts that prompt the badge are announced to screen readers."
        />
        <VButton class="primary" @click="closeModal">Continue</VButton>
      </div>
    </b-modal>
  </div>
</template>

<script>
import NotificationGif from "@/images/Notification.gif";
import VHeader from "./VHeader.vue";
import VButton from "./VButton.vue";

export default {
  name: "VNotificationsConfirmationModal",
  components: { VHeader, VButton },
  props: {
    title: {
      type: String,
      required: true,
    },
    modalId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      gifSrc: NotificationGif,
    };
  },
  methods: {
    closeModal() {
      this.$bvModal.hide(this.modalId || "bv-notifications-confirmation");
    },
  },
};
</script>

<style scoped>
p {
  font-size: var(--font-size-100);
  font-family: var(--font-system-ui);
}

div.padding {
  padding: 0.5rem 0.5rem 1rem 0.5rem;
}

img {
  width: 80%;
  padding: 1rem 0;
}
</style>
